import { Box, Center, Flex, Image, Text } from '@chakra-ui/react';
import Lottie from 'lottie-react';
import React, { useRef, useEffect } from 'react';
import audio from 'src/asset/images/audio.png';
import waveData from 'src/asset/lottie-json/audio_wave.json';
import ListenAudio from '../HelperComponents/ListenAudio';
import useMediaOptions from './useMediaOptions';
import { noImageFoundText } from "src/component/constants";

function ListenWithAudio({ exercise, setSelectedAnswer }) {
  const lottieRef = useRef();
  const {
    mediaList,
    currentlyPlaying,
    onAudioPlay,
    registerAnimationRef,
    unregisterAnimationRef,
    stopAllAudio
  } = useMediaOptions({ exercise, hasAudio: true });

  useEffect(() => {
    const optionKey = mediaList.find(m => currentlyPlaying === `option-${m.key}`)?.key;
    if (optionKey && lottieRef.current) {
      registerAnimationRef(`option-${optionKey}`, lottieRef.current);
      lottieRef.current.play();
    }
    return () => {
      if (optionKey) {
        unregisterAnimationRef(`option-${optionKey}`);
      }
    };
  }, [currentlyPlaying, mediaList, registerAnimationRef, unregisterAnimationRef]);

  const onAnswerClick = (media) => {
    if (currentlyPlaying === `option-${media.key}`) {
      stopAllAudio();
    } else {
      onAudioPlay(media.value, `option-${media.key}`);
    }
    setSelectedAnswer(media);
  };

  return (
    <>
      {(exercise?.audio || exercise?.slowAudio) && (
        <ListenAudio 
          data={exercise} 
          audioControl={{ currentlyPlaying, onAudioPlay }}
        />
      )}
      <Box pt={[5, 5, 20]}>
        <Flex
          direction={['column', 'column', 'row']}
          alignItems="center"
          justifyContent={'center'}
          gap={10}
        >
          {mediaList.map((media, i) => (
            <Center
              key={`${media.key}-${i}`}
              onClick={() => onAnswerClick(media)}
              border="solid lightgray 1px"
              borderRadius={'10px'}
              w={'200px'}
              h="70px"
              cursor={'pointer'}
              boxShadow={currentlyPlaying === `option-${media.key}` ? '2px 5px #2367f0' : ''}
            >
              {currentlyPlaying === `option-${media.key}` ? (
                <Lottie
                  animationData={waveData}
                  loop={true}
                  autoplay={false}
                  lottieRef={lottieRef}
                  style={{ width: 150, height: 70 }}
                />
              ) : (
                <>
                  <Image mr={3} boxSize={'20px'} src={audio} alt={noImageFoundText} />
                  <Text fontSize="xs">Audio {i + 1}</Text>
                </>
              )}
            </Center>
          ))}
        </Flex>
      </Box>
    </>
  );
}

export default ListenWithAudio;